import { useWindyMapStore } from "@/stores/windy-map-store";
import { useEffect, useState } from "react";
import geojson from "@/geojson";
import ReactDOMServer from "react-dom/server";

type GeojsonKey = keyof typeof geojson;
import * as L from "leaflet";
import { useParams } from "react-router-dom";
import { usePhenoQuery } from "@/query/pheno-query";
import useAlertQuery from "@/query/alert-query";
import AlertWidget from "@/components/alert-widget";
import { regions } from "@/utils/region";
import PhenoPopup from "@/components/skydata/pheno-popup";

const PhenoPage: React.FC = () => {
  const { type } = useParams<{
    type:
      | "western"
      | "eastern"
      | "central"
      | "gobi"
      | "cities"
      | "erdenet"
      | "darkhan"
      | "ulaanbaatar";
  }>();
  if (!type || !regions[type]) {
    return <></>; // Handle invalid type
  }
  const { location, zoom } = regions[type];
  const geojsonKeys = regions[type].regions;

  const { data: alertData } = useAlertQuery();
  const { data: phenoData } = usePhenoQuery(type);
  const windyLayer = useWindyMapStore((state) => state.layer);
  const windyMap = useWindyMapStore((state) => state.windyMap);
  const [groupLayer, setGroupLayer] = useState<any>();

  useEffect(() => {
    if (!windyLayer) return;
    console.log("wind layer", windyLayer);

    const newLayer = L.layerGroup().addTo(windyLayer);
    // const newPhenoLayer = L.layerGroup().addTo(layer);
    if (groupLayer) {
      groupLayer.remove();
    }

    setGroupLayer(newLayer);
    return () => {
      newLayer.remove();
    };
  }, [windyLayer]);
  useEffect(() => {
    if (!groupLayer || !windyMap || !phenoData) return;

    groupLayer.clearLayers();
    geojsonKeys.map((name) => {
      const geoData = geojson[name as GeojsonKey];
      L.geoJSON(geoData, {
        style: {
          color: "#4D0368",
        },
      }).addTo(groupLayer);
      const { properties } = geoData;
      if (properties && properties.location && properties.name) {
        const pheno =
          phenoData.find(
            (item) =>
              item.city === properties.name ||
              (properties.name === "Эрдэнэт" && item.city === "Эрдэнэт-Овоо") ||
              (properties.name === "Чингис" && item.city === "Өндөрхаан") ||
              (properties.name === "Налайх" && item.city === "Тэрэлж")
          ) || null;
        if (!pheno) return;
        pheno.city = properties.name;
        const htmlString = ReactDOMServer.renderToString(
          <PhenoPopup pheno={pheno} />
        );
        const icon = L.divIcon({
          html: htmlString,
          className: "pheno-div-icon", // баттай нэг class өгнө
          iconSize: null, // авто хэмжээ авна
        });
        console.log("htmltsring", htmlString);
        const [lat, lng] = properties.location;
        L.marker([lat, lng], { icon })
          .addTo(groupLayer)
          .bindPopup(htmlString, {
            className: "my-popup",
            closeButton: false,
            autoClose: false,
            closeOnEscapeKey: false,
            closeOnClick: false,
          })
          .openPopup();
      }
    });

    windyMap.setView(location, zoom);
  }, [groupLayer, windyMap, phenoData]);

  useEffect(() => {
    if (!windyMap) return;
    const baseZoom = zoom; // анхны zoom, regions[type].zoom-аас авна
    const MIN_SCALE = 0.25;

    const onZoom = () => {
      // эсвэл scale = curZoom / baseZoom ч болно
      document.querySelectorAll<HTMLElement>(".scaled-popup").forEach((el) => {
        const curZoom = windyMap.getZoom();
        const scale = Math.pow(2, curZoom - baseZoom);
        console.log("scale", scale);
        el.style.setProperty("--marker-scale", scale.toString());
        // Зөвхөн scale хувьсагчийг inline-мөрөн дээр шинэчилнэ
        if (scale < MIN_SCALE) {
          // Tailwind ашиглаж байвал
          el.classList.add("hidden");
          // эсвэл pure CSS-ээр:
          // el.style.display = "none";
        } else {
          el.classList.remove("hidden");
          // эсвэл:
          // el.style.display = "";
        }
      });
    };

    windyMap.on("zoom", onZoom);
    return () => {
      windyMap.off("zoom", onZoom);
    };
  }, [windyMap, zoom]);

  return (
    <>
      {alertData &&
        Object.keys(alertData).length > 0 &&
        [
          "darkhan",
          "erdenet",
          "ulaanbaatar",
          "eastern",
          "western",
          "central",
          "gobi",
        ].includes(type) && <AlertWidget type={type} />}
    </>
  );
};

export default PhenoPage;
